enum FundingAccountManualVerificationActionType {
    FUNDING_ACCOUNT_MANUAL_VERIFICATION_LOAD_DATA = "FUNDING_ACCOUNT_MANUAL_VERIFICATION_LOAD_DATA",
}

export default FundingAccountManualVerificationActionType;